import axios from 'axios';

const instance = axios.create({ baseURL: process.env.REACT_APP_URL_BASE });

const request = {
    post: (url, body) => instance.post(url, body, { headers: { "content-type": "multipart/form-data" } } ),
}

export default request;